import axios from 'axios';
import { MediaDTO } from '../dto/MediaDto';

import { routePrefix } from '../app/App';

export async function getMedias(query: string): Promise<MediaDTO[]> {
  const url = `${routePrefix()}medias${query}`;
  const { data } = await axios.get<MediaDTO[]>(url);
  return data;
}